import { SeverityLevel } from '@/shared/enums';

export const severityLevelMap = new Map<string, string>([
  [SeverityLevel.Low, '轻微'],
  [SeverityLevel.Medium, '中等'],
  [SeverityLevel.High, '严重']
]);
